import { convertFigmaColors } from 'themes/convertFigmaColors';
import figmaColors from 'themes/partners/nytimes/json/colors.json';

export const colors = convertFigmaColors(figmaColors);
